import { useQuery } from '@tanstack/react-query';
import { getVideo } from '../services/admin/admin-video.service';
import { ADMIN_VIDEO_KEY } from '../common/utils/video-query-cache';
import { useVideoStatusPolling } from './use-video-status-polling';

export function useVideoReplacement(replacementId: string) {
  const query = useQuery({
    queryKey: [ADMIN_VIDEO_KEY, replacementId],
    queryFn: () => getVideo(replacementId),
  });

  useVideoStatusPolling(query.data ? [query.data] : []);

  return query;
}
